(function (angular, app) {
    'use strict';

    app.directive('spProduct', ['Util', function (Util) {
        return {
            restrict: 'E',
            scope: {
                size: '@',
                text: '@',
                hideCart: '@',
                hideSales: '@',
                product: '=',
                showItemDescription: '<',
                boostProductTags: '<?',
                openProduct: '&?',
                source: '=?',
                itemPosition: '=?',
                itemsCount: '=?',
                componentType: '=?',
                componentPosition: '=?',
                carouselName: '=?',
                specialId: '=?'
            },
            controller: ['$scope', '$rootScope', 'Config','User', 'Cart', 'Util', function ($scope, $rootScope, Config, User, Cart, Util) {
                var _listeners = [];
                function init(){
                    $scope.productSpecials = Util.filterProductSpecials($scope.product.isCaseMode ? $scope.product.branch.case : $scope.product.branch); 
                    $scope.specialToShow = Util.getSpecialToShow($scope.productSpecials);
                    $scope.isShowTprDisplay = false;
                    if (Config.isUs &&
                        Config.retailer.settings.isNewPromotionDesignEnabled === 'true' &&
                        $scope.product &&
                        $scope.specialToShow &&
                        $scope.specialToShow.isTPRPromotion
                    ) {
                        $scope.isShowTprDisplay = true;
                    }
                }
                init();
                $scope.hasClubSpecial = Util.productHasClubSpecial($scope.product.branch);
                $scope.getLine = getLine;
                $scope.isHideAddButton = Util.isHideAddButton($scope.product);

                var _isRetailerPremiumReplacementsEnabled = Config.retailer.settings.enablePersonalReplacement;
                
                function getLine() {
                    return Util.getProductCartLine($scope.product, $scope.product.isCaseMode);
                }

                $scope.showReplacementLabel = false;
                
                if (_isRetailerPremiumReplacementsEnabled) {
                    $rootScope.$on('cart.update.complete', function() {
                        Util.setReplacement($scope)
                    })
                    $rootScope.$on('loginForAnalyticServiceProvider', function() {
                        Util.setReplacement($scope)
                    })
                }
                _listeners.push($scope.$watch('product.isCaseMode', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                      init();
                    }
                }));
                Util.destroyListeners($scope, _listeners);
            }],
            templateUrl: 'template/directives/sp-product/index.html',
            link: function ($scope, $element) {
                $element.attr('itemscope', '');
                $element.attr('itemtype', 'http://schema.org/Product');
                $element.attr('role', 'none');
                $element.bind('focus', function () {
                    $element.on('mouseover', function () {
                        $element.addClass('mouse-hover');
                    });

                    $element.on('mouseout', function () {
                        $element.removeClass('mouse-hover');
                    });
                });
            }
        };
    }]);
})(angular, app);